import { AdminApi } from './';

const {REACT_APP_API_BASE_URL, REACT_APP_API_VERSION} = process.env;

export class CouponApi {
    static create (data) {
        return fetch(`${REACT_APP_API_BASE_URL}/${REACT_APP_API_VERSION}/coupons`, {
            ...AdminApi.PostDefualtMethod,
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/coupon.js